module.exports = __webpack_public_path__ + "static/media/slide.d956912c.png";